const FALLBACK_REDIRECT_PATH = "/home";

// Allows only same-origin app paths; anything else falls back to /home.
export const getSafeRedirectPath = (to: string): string => {
  const isAppPath = to.startsWith("/") && !to.startsWith("//");
  const hasUnsafeChars = /[\\\s\p{Cc}]/u.test(to);
  return isAppPath && !hasUnsafeChars ? to : FALLBACK_REDIRECT_PATH;
};
